// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__22o-f","right":"styles_right__38x-5"};